import { useStore } from '@longsien/react-store';
import { useWidgetContext } from '@/components/providers/WidgetProvider';
import { parkingAvailabilityStore } from '../../../../../stores/parking-availability';
import { ClaytonParking } from './ClaytonParking';

export const ClaytonParkingContainer = (props) => {
  const { editActiveWidget } = useWidgetContext();
  const [parkingAvailability] = useStore(parkingAvailabilityStore);

  const forwardedProps = {
    ...props,
    editActiveWidget,
    parkingAvailability,
  };

  return <ClaytonParking {...forwardedProps} />;
};
